import { Box } from "@mui/material"
import type { FC } from "react"
import { useMemo } from "react"
import { useFormContext } from "react-hook-form"

import { ACCOUNT_TYPE_LABELS, CLASSIFICATION_ACCOUNT_TYPES } from "../../constants"
import type { ChartOfAccountsSearchParams } from "../../types/searchParams"

import { FilterCheckbox } from "@/components/common/Filters"
import { GlAccountType } from "@/graphql/codegen/graphql"

const accountTypeList = Object.values(GlAccountType)

interface AccountTypeFilterProps {
  onFilterChange: (name: keyof ChartOfAccountsSearchParams, value: unknown) => void
}

export const AccountTypeFilter: FC<AccountTypeFilterProps> = ({ onFilterChange }) => {
  const { control, watch } = useFormContext()
  const accountTypesValue = watch("accountTypes") || []
  const classificationValue = watch("classification")

  // Determine which account types are enabled based on selected classification
  const enabledTypes = useMemo(() => {
    if (!classificationValue) {
      return accountTypeList
    }

    const types = CLASSIFICATION_ACCOUNT_TYPES[classificationValue as keyof typeof CLASSIFICATION_ACCOUNT_TYPES]
    return types ? Array.from(types) : []
  }, [classificationValue])

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      {accountTypeList.map((accountType) => {
        const isDisabled = !enabledTypes.includes(accountType)
        return (
          <FilterCheckbox
            key={accountType}
            label={ACCOUNT_TYPE_LABELS[accountType]}
            value={accountType}
            control={control}
            name='accountTypes'
            values={accountTypesValue}
            onFilterChange={(values: string[]) => onFilterChange("accountTypes", values)}
            disabled={isDisabled}
          />
        )
      })}
    </Box>
  )
}
